export class CreatePolicyForCompany {

    constructor(public applicationName: string, public referenceId: number, public name: string, public policyTemplatePath = "Company") {

    }
}

export class CreatePolicyForCompanyResponse {
    id: number;
}